if (!customElements.get('localization-form')) {
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
				button: this.querySelector('button'),
				panel: this.querySelector('.f-disclosure-list')
			};
			this.dropdownPosRaf = null
			this.boundHandleDropdownPos = this.scheduleDropdownPos.bind(this)

			this.elements.panel.removeAttribute('hidden')
			this.elements.button.addEventListener('click', this.openSelector.bind(this));
			this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

			this.scheduleDropdownPos()
			window.addEventListener('resize', this.boundHandleDropdownPos, { passive: true })
		}

		scheduleDropdownPos() {
			if (this.dropdownPosRaf) return
			this.dropdownPosRaf = requestAnimationFrame(() => {
				this.dropdownPosRaf = null
				this.handleDropdownPos()
			})
		}

		handleDropdownPos() {
			const panel = this.elements.button.nextElementSibling
			if (!panel) return
			const offsetButton = this.elements.button.getBoundingClientRect().right
			const shouldAlignRight = (window.innerWidth - offsetButton) < 220
			panel.classList.toggle('f-disclosure-list__right', shouldAlignRight)
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.removeAttribute('open')
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			const form = this.querySelector('form');
			this.elements.input.value = event.currentTarget.dataset.value;
			if (form) form.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.toggleAttribute('open')
			this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
		}

		closeSelector(event) {
			const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON' || event.relatedTarget && !event.relatedTarget.classList.contains('f-disclosure-list__option')
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel(shouldClose);
			}
		}

		disconnectedCallback() {
			window.removeEventListener('resize', this.boundHandleDropdownPos)
			if (this.dropdownPosRaf) {
				cancelAnimationFrame(this.dropdownPosRaf)
				this.dropdownPosRaf = null
			}
		}
	}
	customElements.define('localization-form', LocalizationForm);
}
